import { render, staticRenderFns } from "./PointShadow.vue?vue&type=template&id=904e0d74&scoped=true&"
import script from "./PointShadow.vue?vue&type=script&lang=js&"
export * from "./PointShadow.vue?vue&type=script&lang=js&"
import style0 from "./PointShadow.vue?vue&type=style&index=0&id=904e0d74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904e0d74",
  null
  
)

export default component.exports